<template>
  <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
    <path d="M7 17l5-5-5-5"/>
    <path d="M17 7l-5 5 5 5"/>
  </svg>
</template>

<script>
export default {
  name: 'ArrowsIcon'
}
</script> 